export function animateCubicBezier(onUpdate, controlPoints, duration) {
    // http://www.mat.unimi.it/users/alzati/Geometria_Computazionale_98-99/apps/bezierpong/Teoria.html

    function cubicBezier(t, initValue, p1, p2, endValue) {
        const x = Math.pow(1 - t, 3) * initValue.x +
            3 * Math.pow(1 - t, 2) * t * p1.x +
            3 * (1 - t) * Math.pow(t, 2) * p2.x +
            Math.pow(t, 3) * endValue.x;

        const y = Math.pow(1 - t, 3) * initValue.y +
            3 * Math.pow(1 - t, 2) * t * p1.y +
            3 * (1 - t) * Math.pow(t, 2) * p2.y +
            Math.pow(t, 3) * endValue.y;

        return {x, y};
    }

    let startTime;

    function animate(time) {
        if (!startTime) startTime = time;
        const elapsedTime = time - startTime;
        let t = Math.min(elapsedTime / duration, 1);

        const defaultP0 = {x: 0, y: 0}
        const defaultP1 = {x: 50, y: .5}
        const defaultP2 = {x: 50, y: .8}
        const defaultP3 = {x: 50, y: 1}

        const position = cubicBezier(t, controlPoints[0] = defaultP0, controlPoints[1] = defaultP1, controlPoints[2] = defaultP2, controlPoints[3] = defaultP3);

        onUpdate(position);

        if (t < 1) requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
}

